import React from 'react';
import { styled } from '@mui/material';

const PREFIX = 'FormLabelCompGroup';

const classes = {
  root: `${PREFIX}-root`,
  title: `${PREFIX}-title`,
};

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    marginBottom: '1rem',
  },

  [`& .${classes.title}`]: {
    fontSize: '1rem',
    fontWeight: 700,
  },
}));

type FormLabelCompGroupProps = {
  title: string;
};

const FormLabelCompGroup = ({ title }: FormLabelCompGroupProps) => (
  <Root className={classes.root}>
    <span className={classes.title}>{title}</span>
  </Root>
);

export default FormLabelCompGroup;
